module.exports = __webpack_public_path__ + "static/media/proj20_img3.328502d4.jpg";